<template>
  <div class="addUser">
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="userForm.id ? $t('addUser.edit') : $t('addUser.add')"
      v-dialogDrag
      :visible.sync="dialogAddUser"
      width="760px"
      top="9vh"
      @closed="closeDialog"
      @open="openDialog"
      :close-on-click-modal="false"
      custom-class="adduser"
    >
      <div v-loading="loadingForm" :element-loading-text="$t('common.request')">
        <el-form :label-position="labelPosition" :rules="rules" ref="userForm" label-width="80px" :model="userForm">
          <!-- 登录 -->
          <div class="form-section">
            <h4 class="form-section__title">{{ $t("userForm.secSignin") }}</h4>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('userForm.loginEmail')" prop="userName" :error="error.userName">
                  <el-input
                    v-model="userForm.userName"
                    :placeholder="$t('addUser.pUsername')"
                    autocomplete="off"
                  ></el-input>
                  <p class="field-hint">{{ $t("userForm.loginEmailHint") }}</p>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="!userForm.id">
              <el-col :span="12">
                <el-form-item :label="$t('addUser.password')" prop="passWord">
                  <el-input
                    type="password"
                    v-model="userForm.passWord"
                    :placeholder="$t('addUser.pPassword')"
                    autocomplete="off"
                  ></el-input>
                  <p class="field-hint">{{ $t("userForm.passwordHint") }}</p>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('addUser.checkPassword')" prop="checkPassword">
                  <el-input
                    type="passWord"
                    v-model="userForm.checkPassword"
                    :placeholder="$t('addUser.pCheckPassword')"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 基本信息 -->
          <div class="form-section">
            <h4 class="form-section__title">{{ $t("userForm.secProfile") }}</h4>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item :label="$t('userForm.displayName')" prop="nickName" :error="error.nickName">
                  <el-input
                    v-model="userForm.nickName"
                    :placeholder="$t('addUser.pNickname')"
                    autocomplete="off"
                  ></el-input>
                  <p class="field-hint">{{ $t("userForm.displayNameHint") }}</p>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('addUser.phone')" prop="phone">
                  <el-input v-model="userForm.phone" :placeholder="$t('addUser.pPhone')" :error="error.phone"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('userForm.role')" prop="roleId">
                  <el-select
                    v-model="userForm.roleId"
                    class="full-width"
                    :no-data-text="$t('common.noData')"
                    :no-match-text="$t('common.noData')"
                    :placeholder="$t('addUser.pUserType')"
                  >
                    <el-option
                      v-for="item in userTypeList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 通知与地区 -->
          <div class="form-section">
            <h4 class="form-section__title">{{ $t("userForm.secNotify") }}</h4>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('userForm.alertEmails')" prop="email">
                  <el-input v-model="userForm.email" :placeholder="$t('addUser.pEmail')" :error="error.email"></el-input>
                  <p class="field-hint">{{ $t("userForm.alertEmailsHint") }}</p>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('addUser.timeZone')" prop="timeZone">
                  <el-select
                    v-model="userForm.timeZone"
                    class="full-width"
                    :no-data-text="$t('common.noData')"
                    :no-match-text="$t('common.noData')"
                    clearable
                    :placeholder="$t('addUser.pTimeZone')"
                  >
                    <el-option v-for="item in timeZoneList" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                  <p class="field-hint">{{ $t("userForm.timeZoneHint") }}</p>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('addUser.country')" prop="country">
                  <el-select
                    v-model="userForm.country"
                    class="full-width"
                    :no-data-text="$t('common.noData')"
                    :no-match-text="$t('common.noData')"
                    clearable
                    :placeholder="$t('addUser.pCountry')"
                  >
                    <el-option v-for="item in countryList" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('userForm.address')" prop="locale">
                  <el-input v-model="userForm.locale" :placeholder="$t('addUser.pAddress')"></el-input>
                  <p class="field-hint">{{ $t("userForm.addressHint") }}</p>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" style="padding-top: 0 !important">
        <el-button @click="cancel">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" :disabled="loadingForm" @click="submitForm('userForm')">{{
          $t("common.definite")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: "AddUser",
    data() {
      const passWord = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t("addUser.pPassword")));
        } else {
          const reg = new RegExp("(?![0-9A-Z]+$)(?![0-9a-z]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,50}$");
          if (!reg.test(value)) {
            callback(new Error(this.$t("addUser.vPassword")));
          }
          if (this.userForm.checkPassword !== "") {
            this.$refs.userForm.validateField("checkPassword");
          }
          callback();
        }
      };
      const userName = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t("login.userName")));
        } else {
          const reg = new RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$");
          if (!reg.test(value)) {
            callback(new Error(this.$t("login.cEmailError")));
          }
          callback();
        }
      };
      const checkPassword = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t("addUser.pCheckPassword")));
        } else if (value !== this.userForm.passWord) {
          callback(new Error(this.$t("addUser.notPwd")));
        } else {
          callback();
        }
      };
      return {
        loadingForm: false,
        error: {
          nickName: "",
          userName: "",
          phone: ""
        },
        labelPosition: "top",
        clear: false,
        rules: {
          nickName: [
            {
              required: true,
              message: this.$t("addUser.pNickname"),
              trigger: "blur"
            },
            {
              min: 3,
              max: 32,
              message: this.$t("addUser.rLen"),
              trigger: "blur"
            }
          ],
          userName: [
            {
              required: true,
              message: this.$t("addUser.pUsername"),
              trigger: "blur"
            },
            { validator: userName, trigger: "blur" }
          ],
          passWord: [
            { validator: passWord, trigger: "blur" },
            { required: true, trigger: "blur" }
          ],
          checkPassword: [
            { validator: checkPassword, trigger: "blur" },
            { required: true, trigger: "blur" }
          ],

          timeZone: [
            {
              required: true,
              message: this.$t("addUser.vLoginFlag"),
              trigger: "blur"
            }
          ],
          email: [
            {
              required: true,
              message: this.$t("addUser.pEmail"),
              trigger: "blur"
            }
          ],
          phone: [
            {
              required: true,
              message: this.$t("addUser.pPhone"),
              trigger: "blur"
            }
          ],
          roleId: [
            {
              required: true,
              message: "please choose",
              trigger: "blur"
            }
          ],
          country: [
            {
              required: true,
              message: "please choose",
              trigger: "blur"
            }
          ],
          locale: [
            {
              require: true,
              message: "please enter",
              trigger: "blur"
            }
          ]
        }
      };
    },
    props: {
      dialogAddUser: Boolean,
      userForm: Object,
      userTypeList: Array,
      timeZoneList: Array,
      countryList: Array
    },
    mounted() {
      this.clear = false;
    },
    methods: {
      // 添加或编辑用户
      submitForm(formName) {
        this.disabled = true;
        this.$refs[formName].validate(valid => {
          if (valid) {
            //  this.loadingForm = true;
            const obj = {};
            Object.keys(this.userForm).forEach(key => {
              obj[key] = this.userForm[key] ? this.userForm[key] : "";
            });
            if (!this.userForm.id) {
              obj.passWord = this.$md5(obj.passWord);
              obj.checkPassword = this.$md5(obj.checkPassword);
            }

            let url = this.$url.User.insert;
            let method = this.$method.post;
            if (this.userForm.id) {
              url = this.$url.User.update;
              method = this.$method.put;
            }
            this.$api
              .request(url, method, obj)
              .then(res => {
                if (res.code === 0) {
                  this.$notify({
                    title: this.$t("common.tip"),
                    message: this.userForm.id ? this.$t("addUser.up") : this.$t("addUser.save"),
                    type: "success"
                  });
                  this.clear = true;
                  this.cancel(this.userForm.id ? "update" : "save");
                } else {
                  this.$toolUtil.msg(res, this.error);
                }
                this.loadingForm = false;
              })
              .catch(() => {
                this.loadingForm = false;
              });
          }
        });
      },
      // 清除表单校验信息
      closeDialog() {
        this.clearValidate("userForm");
        if (!this.addOrEdit) {
          this.$toolUtil.clearForm(this.userForm);
        } else {
          if (this.clear) {
            this.$toolUtil.clearForm(this.userForm);
          }
        }
        this.cancel();
      },
      openDialog() {},
      // 清除表单校验信息
      clearValidate(formName) {
        this.$refs[formName].clearValidate();
      },
      // 关闭弹框
      cancel(state, code) {
        this.$emit("cancel", false, state, code);
      }
    }
  };
</script>
<style lang="scss" scoped>
  .el-form--label-top .el-form-item__label {
    line-height: normal;
    margin-bottom: 6px;
  }
  .adduser {
    .el-dialog__body {
      height: auto !important;
      padding: 10px 20px 20px 20px;
    }
    .el-dialog__footer {
      padding: 0 20px 20px;
    }
  }

  .form-section {
    margin-bottom: 18px;
    padding: 14px 16px 4px;
    border: 1px solid var(--vtm-line);
    border-radius: var(--vtm-r-md);
    background: var(--vtm-surface-2);

    &:last-child {
      margin-bottom: 0;
    }
  }
  .form-section__title {
    margin: 0 0 12px;
    font-family: var(--vtm-display);
    font-size: 13.5px;
    font-weight: 600;
    color: var(--vtm-heading);
  }

  .field-hint {
    margin: 4px 0 0;
    font-size: 12px;
    line-height: 1.4;
    color: var(--vtm-ink-3);
  }

  .full-width {
    width: 100%;
  }
</style>
